import {
  formatMessageValue,
  getMessageEntries,
  humanizeLabel,
  MAX_MESSAGE_FIELDS,
} from '../audit-log.utils';

import type { AuditLog } from '@/types/audit-log.type';

type Props = {
  log: AuditLog;
};

export function AuditLogMessage({ log }: Props) {
  const entries = getMessageEntries(log);

  if (entries.length === 0) {
    return <span className="text-sm text-muted-foreground">No additional details</span>;
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {entries.slice(0, MAX_MESSAGE_FIELDS).map(([key, value]) => {
        const formattedValue = formatMessageValue(value);

        return (
          <span
            key={`${log.id}-${key}`}
            className="inline-flex max-w-full items-center gap-1 rounded-md border border-border/60 bg-muted/40 px-2 py-1 text-xs"
            title={`${humanizeLabel(key)}: ${formattedValue}`}
          >
            <span className="text-muted-foreground">{humanizeLabel(key)}</span>
            <span className="max-w-[20rem] truncate font-medium text-foreground">
              {formattedValue}
            </span>
          </span>
        );
      })}
      {entries.length > MAX_MESSAGE_FIELDS && (
        <span className="inline-flex items-center rounded-md border border-dashed px-2 py-1 text-xs text-muted-foreground">
          +{entries.length - MAX_MESSAGE_FIELDS} more
        </span>
      )}
    </div>
  );
}
